import { ConfigurationType, OpenAIConfigurationKeys } from './parser';
import { SalesforceConfigurationType } from './ai';

export interface PotentialIssue {
  configurationName: string;
  objectName: string;
  configurationType: SalesforceConfigurationType;
  title: string;
  description: string;
  severity: PotentialIssueSeverity;
}

// TODO SWEEP-8083 - @karolinap once homepage doesn't use keys, delete this
export interface PotentialIssueWithKey {
  configurationName: string;
  objectName: string;
  configurationType: OpenAIConfigurationKeys;
  title: string;
  description: string;
  severity: PotentialIssueSeverity;
}

export const PotentialIssueSeverityValues = ['Low', 'Medium', 'High'] as const;
export type PotentialIssueSeverity = typeof PotentialIssueSeverityValues[number];

export enum ConfigurationWithCounters {
  customFields = 'customFields',
  apexClasses = ConfigurationType.apexClasses,
  apexTriggers = ConfigurationType.apexTriggers,
  recordTypes = ConfigurationType.recordTypes,
  flows = ConfigurationType.flows,
  validationRules = ConfigurationType.validationRules,
  approvalProcesses = ConfigurationType.approvalProcesses,
}

export type OrgConfigurationCounts = Record<ConfigurationWithCounters, number>;

export const AI_QUESTIONS_LIMIT = 5;

export type Homepage = {
  potentialIssues: PotentialIssueWithKey[];
  counters: OrgConfigurationCounts;
};
